<template>
  <el-table-column
    v-if="column.children && column.children.length"
    :key="column.prop"
    v-bind="column"
    :align="align"
  >
    <template v-if="column.explains" v-slot:header="scope">
      <template v-if="column.explains">
        {{ column.label }}
        <el-tooltip class="item" effect="light" placement="top-start">
          <div slot="content" v-html="column.explains" />
          <img :src="tipSrc" alt="" class="tipsImg" />
        </el-tooltip>
      </template>
    </template>
    <ElTableColumnCustom
      v-for="subColumn in column.children"
      :key="`${column.prop || column.label}--${
        subColumn.prop || subColumn.label
      }`"
      :column="subColumn"
    />
  </el-table-column>

  <!-- scope注入 -->
  <el-table-column
    v-else-if="column.customSortable || column.component || column.header"
    :key="column.prop || column.label"
    v-bind="column"
    :align="align"
  >
    <template v-if="column.component" v-slot:default="scope">
      <component
        :is="compile(column.component, column, scope)"
        v-if="'template' in column.component"
      />
      <component
        :is="column.component"
        v-else
        :column="column"
        :scope="scope"
      />
    </template>

    <template
      v-if="column.header || column.customSortable"
      v-slot:header="scope"
    >
      <template v-if="column.header">
        <component
          :is="compile(column.header, column, scope)"
          v-if="'template' in column.header"
        />
        <component :is="column.header" v-else :column="column" :scope="scope" />
      </template>

      <template v-if="column.customSortable">
        <span class="sort-btn" @click="descend(column.prop)">
          {{ column.label }}
          <i
            :class="[
              'icon-anjiangxupailie',
              'sort-btn-icon',
              { active: sortProp === column.prop },
            ]"
          />
        </span>
      </template>
    </template>
  </el-table-column>

  <!-- 只显示占比条和百分比 -->
  <el-table-column
    v-else-if="column.progress"
    :key="column.prop"
    v-bind="column"
    :align="align"
  >
    <template slot-scope="scope">
      <el-progress
        :percentage="scope.row[column.progress.valueKey]"
        v-bind="column.progress"
        type="line"
      />
    </template>
  </el-table-column>

  <!--显示原始值与占比条和百分比值 -->
  <el-table-column
    v-else-if="column.valueProgress"
    :key="column.prop"
    v-bind="column"
    :align="align"
  >
    <template slot-scope="scope">
      <span class="progressbar-value">{{
        scope.row[scope.column.property]
      }}</span>
      <el-progress
        :percentage="scope.row[column.valueProgress.valueKey]"
        v-bind="column.valueProgress"
        type="line"
      />
    </template>
  </el-table-column>

  <el-table-column
    v-else-if="column.mold === 'customTipsBilling'"
    :key="column.prop || column.label"
    v-bind="column"
    :align="align"
  >
    <template slot-scope="scope">
      <el-popover
        trigger="manual"
        placement="left"
        v-model="scope.row.elPopoverVisible"
        v-if="!column.condition || column.condition(scope.row)"
      >
        <div
          class="custom-tips-billing-content"
          v-if="scope.row.elPopoverVisible"
        >
          <div
            class="custom-tips-billing-content-box"
            v-for="(options, index) in column.options"
            :key="index"
          >
            <div
              class="custom-tips-billing-content-label"
              v-for="(option, oindex) in options"
              :key="oindex"
            >
              {{ option.label }}: {{ getValue(info, option) }}
            </div>
          </div>
        </div>
        <div slot="reference" class="custom-tips-billing-reference">
          <div
            @click="elPopoverShow(column, scope.row)"
          >
            {{
              column.formatter
                ? column.formatter(scope.row)
                : scope.row[column.prop]
            }}
          </div>
        </div>
      </el-popover>
      <div v-else class="custom-tips-billing-reference">
        {{
          column.formatter
            ? column.formatter(scope.row)
            : scope.row[column.prop]
        }}
      </div>
    </template>
  </el-table-column>
  <el-table-column
    v-else
    :key="column.prop || column.label"
    v-bind="column"
    :align="align"
    show-overflow-tooltip
  >
    <template v-if="column.explains" v-slot:header="scope">
      <template v-if="column.explains">
        {{ column.label }}
        <el-tooltip class="item" effect="light" placement="top-start">
          <div slot="content" v-html="column.explains" />
          <img :src="tipSrc" alt="" class="tipsImg" />
        </el-tooltip>
      </template>
    </template>
  </el-table-column>
</template>

<script>
import Vue from "vue";
import tipSrc from "@/assets/img/tips.png";

export default {
  name: "ElTableColumnCustom",

  props: {
    column: {
      default: () => {},
      type: Object,
    },

    sortProp: {
      default: "",
      type: String,
    },
  },

  data() {
    return {
      tipSrc,
      info: {},
      clearInterval: [],
    };
  },
  computed: {
    align() {
      const { children, align } = this.column;

      return children ? "center" : align ? align : "left";
    },
  },
  mounted() {
      window.addEventListener("click", ()=>{
        this.clearInterval.forEach((item) => {
          item.hide();
        });
      });
  },
  methods: {
    compile(component, column, slotScope) {
      let template = Vue.compile(component.template);
      const data = {
        data() {
          return Object.assign({}, component.data, {
            column,
            scope: slotScope,
          });
        },
      };

      return Object.assign({}, template, data, component);
    },

    descend(prop) {
      this.$emit("sortPropChange", prop);
    },
    elPopoverShow(column, row) {

      if (row.elPopoverVisible) {
        row.elPopoverVisible = false;
        return;
      }
      
      this.clearInterval.forEach((item) => {
        item.hide();
      });
      this.clearInterval[row.id] = {
        hide: () => {
          row.elPopoverVisible = false;
        },
        row: row,
      };

      if (!column.url) {
        row.elPopoverVisible = true;
        this.info = row;
        return false;
      } else {
        this.loadData(column, row);
      }

    },
    loadData(column, row) {
      this.$axios.post(column.url, column.params(row)).then((res) => {
        this.info = res.data;
        row.elPopoverVisible = true;
      });
    },
    getValue(row, option) {
      let nameArr = option.value.split(".");

      if (nameArr.length >= 2) {
        let obj = row[nameArr[0]];

        for (let i = 1; i < nameArr.length - 1; i++) {
          obj = obj[nameArr[i]];
        }
        if (!obj) {
          return "";
        }
        let value = obj[nameArr[nameArr.length - 1]];
        if (option.formatter) {
          value = option.formatter(row);
        }
        return value;
      } else {
        if (!row) {
          return "";
        }
        let value = row[option.value];
        if (option.formatter) {
          value = option.formatter(row);
        }
        return value;
      }
    },
  },
};
</script>

<style lang="scss">
.custom-tips-billing-content {
  padding: 10px;
  font-size: 12px;
  color: #59687e;
  &-box:first-child {
    padding-bottom: 10px;
  }
  &-box + &-box {
    padding-top: 10px;
    border-top: 1px dashed #dae2ef;
  }
}
.custom-tips-billing-reference {
  font-size: 12px;
  cursor: pointer;
 
  &:hover {
    color: #4061f8;
  }
  >div{
  text-decoration:underline,
  }
}
.sort-btn {
  display: inline-block;
  width: 100%;
  // padding: 0 10px 0 0;
  background-color: transparent;
  color: inherit;
  border: none;
  font-size: inherit;
  font-weight: inherit;
  min-width: 100%;
  position: relative;
  white-space: normal;
  &-icon {
    cursor: pointer;
    color: #c8cdde;
    position: absolute;
    right: -4px;
    top: 58%;
    transform: translateY(-50%);
    &.active {
      color: #258ff8;
    }
    &:hover {
      color: #258ff8;
    }
  }
}
</style>